// React
import PropTypes from "prop-types";
import React, { cloneElement, isValidElement } from "react";
// Helpers
import { compact, isEmpty, map } from "@mefisto/utils";
// Framework
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { TableBody as TableBodyComponent } from "@material-ui/core";
// Components
import TableEmptyPlaceholder from "../TableEmptyPlaceholder";
import TableErrorPlaceholder from "../TableErrorPlaceholder";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const TableBody = ({
  rows,
  items,
  loading,
  error,
  draggable,
  emptyTitle,
  emptySubtitle,
  onRefresh,
}) => {
  // Render
  return (
    <TableBodyComponent>
      {error && <TableErrorPlaceholder onRefresh={onRefresh} />}
      {!loading && !error && (
        <SortableContext items={items} strategy={verticalListSortingStrategy}>
          {isEmpty(rows) ? (
            <TableEmptyPlaceholder
              title={emptyTitle}
              subtitle={emptySubtitle}
            />
          ) : (
            compact(
              map(rows, (row, index) => {
                return (
                  isValidElement(row) &&
                  cloneElement(row, {
                    key: items?.[index],
                    draggable,
                    __renderProps: {
                      key: items?.[index],
                      index,
                    },
                  })
                );
              })
            )
          )}
        </SortableContext>
      )}
    </TableBodyComponent>
  );
};

TableBody.propTypes = {
  rows: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.object,
  emptyTitle: PropTypes.string,
  emptySubtitle: PropTypes.string,
  onRefresh: PropTypes.func,
};

export default TableBody;
